import { styled } from '@mui/material';

const StyledMain = styled('main')({
  height: 'calc(100vh - 8rem)',
  padding: '2rem 4.8rem',
});

export default StyledMain;
